export function maskCreditCardNumber(cardNumber: string | undefined) {
	if (cardNumber) {
		const length = cardNumber.length;
		const lastFourDigits = cardNumber.substring(length - 4);
		const prefix = cardNumber.substring(0, length - 4);
		const masked = prefix.replaceAll(/\w/g, "*");
		return masked + lastFourDigits;
	}
}
